import React from "react";
import "./Loader.css"; // Ensure you have the appropriate CSS for the loader

function Loader(props) {
    return (
        <div className="loader-container">
            <div hidden={props.hidden} className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default Loader;